import React from 'react'
import { useMovieParam } from '../../hooks/useMovieParam'
import styled from 'styled-components'

const Container = styled.div`
  background-color: var(--dark);
  height: 100%;
`

const Video = styled.video`
  width: 100%;
`

export const Body = (): JSX.Element => {
  const movie = useMovieParam()

  return <Container>{movie != null &&
    <Video src={movie.url} controls autoPlay={true}/>
  }</Container>
}
